<template>
  <div class="container">
    <Advbar></Advbar>
    <div class="main">
      <div class="left">
        <div class="left1">
          <Categorytree v-if="bread.length" :flag="bread[0].id" @treeclick="navclick"/>
        </div>
        <div class="left2">
          <Newsbar/>
        </div>
        <div class="left3">
          <Contactbar/>
        </div>
      </div>
      <v-card outlined class="right mt-2 ml-2">
        <v-sheet
          height="40"
          dark
          color="light-blue darken-3"
          class="d-flex justify-space-between align-center px-4 mb-1">
          <div class="d-flex align-center">
            <v-icon color="white">mdi-tag-outline</v-icon>
            <v-breadcrumbs :items="bread" large>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item>
                  <span class="text-button">{{ item[$store.state.lang+'_name']}}</span>
                </v-breadcrumbs-item>
              </template>
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
            <v-icon v-if="ischild == 'true'" small>mdi-chevron-right</v-icon>
            <div  v-if="ischild == 'true'" class="text-button">{{item_sel[$store.state.lang+'_name']}}</div>
          </div>
          <v-chip light v-if="ischild == 'true'" @click="back()"><v-icon >mdi-chevron-left</v-icon>BACK</v-chip>
        </v-sheet>
        <Item v-if="ischild == 'true'" family="brand" :childid="childid" @get_item="get_item"/>
        <v-sheet v-else>
          <v-sheet outlined>
            <v-overlay opacity="0.2" absolute :value="brandsloading">
              <v-progress-circular indeterminate color="orange" width="5" size="30"></v-progress-circular>
            </v-overlay>
            <v-sheet class="d-flex flex-wrap">
              <v-card
                width="17.5%"
                v-for="i in brands"
                :key="i.id"
                class="mx-2 my-2 d-flex align-center"
                @click="item_click(i.id)">
                <v-img
                  contain
                  width="100%"
                  height="100"
                  :src="i.thumbnail">
                </v-img>
              </v-card>
            </v-sheet>
          </v-sheet>
          <v-divider class="mx-5 my-1"></v-divider>
          <div class="text-center my-5">
            <v-pagination
              v-model="current_page"
              :length="page_sum"
              :total-visible="10"
              @input="page_change">
            </v-pagination>
          </div>
        </v-sheet>
      </v-card>
    </div>
  </div>
</template>

<script>
import Advbar from '@/components/Advbar.vue'
import Categorytree from '@/components/Categorytree.vue'
import Newsbar from '@/components/Newsbar.vue'
import Contactbar from '@/components/Contactbar.vue'
import Item from '@/components/Item.vue'

export default {
  name: 'Brandlist',
  components: {
    Categorytree,
    Newsbar,
    Advbar,
    Contactbar,
    Item,
  },
  data(){
    return{
      brandlist_io_api:'brandlist/io/',
      bread_io_api:'bread/io/',
      bread:[],
      brands:[],
      page_sum:0,
      current_page:1,
      limit:20,
      item_sel:{},
      brandsloading:false,
    }
  },
  computed:{
    flag(){
      return Number(this.$route.query.flag);
    },
    ischild(){
      return this.$route.query.ischild;
    },
    childid(){
      return Number(this.$route.query.childid);
    },
  },
  methods:{
    page_change(x){
      this.current_page = x;
      this.fetch();
    },
    item_click(id){
      this.$router.push({
        path:'/brandlist',
        query:{
          flag:this.flag,
          ischild:'true',
          childid:id,
        },
      });
    },
    navclick(val){
      this.$router.push({
        path:'/brandlist',
        query:{
          flag:val,
          ischild:'false',
        },
      });
    },
    get_item(x){
      this.item_sel = x;
    },
    back(){
      this.$router.go(-1);
    },
    fetch(){
      this.brandsloading = true;
      let postdata = {};
      postdata.pageflag = this.current_page;
      postdata.key = this.flag;
      postdata.limit = this.limit;
      this.$axios.post(this.$store.state.baseurl + this.brandlist_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.brands = response.data.data;
                this.page_sum = response.data.page_sum;
                this.brandsloading = false;
              }
            }
          )
          .catch(function (e){})
    },
    fetch_bread(){
      let postdata = {};
      postdata.flagid = this.flag;
      this.$axios.post(this.$store.state.baseurl + this.bread_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.bread = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
    this.fetch_bread();
  },
  watch:{
    flag(){
      this.fetch();
      this.fetch_bread();
    }
  }
}
</script>

<style scoped>
.main{
  display:flex;
}
.left{
  width:25%;
}
.left1{
  min-height:200px;
  margin-top:8px;
}
.left2{
  margin-top:8px;
}
.left3{
  min-height:200px;
  margin-top:8px;
}
.right{
  width:70%;
  flex-grow:1;
}
.v-breadcrumbs{
  padding:8px 12px;
}
.divider{
  height:20px;
  width:2px;
  background:#fff;
}
</style>
